import { render } from "./index.vue?vue&type=template&id=06c63d4a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=06c63d4a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-06c63d4a"

export default script